import React, { useState, useEffect } from 'react';
import ClaimStatusModal from './ClaimStatusModal';
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Table,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  NavItem,
  NavLink,
  Row,
  TabContent,
  FormFeedback,
  TabPane,
} from 'reactstrap';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import * as Yup from 'yup';
import { isEmpty, isNull } from 'lodash';
import { useFormik } from 'formik';
import { useMutation, useQueryClient } from 'react-query';
import { useSelector, useDispatch } from 'react-redux';
import {
  getMemberByIdNumberApi,
  getNextOfKinApi,
  getDependantsApi,
} from 'api/member';

//Import Breadcrumb
import Breadcrumbs from '../../components/Common/Breadcrumb';
import { addClaim, uploadMedia } from 'api/claim';
import { getAllPolicyApi } from 'api/policy';
import LoadingSpinner from '../Claim/loadingSpinner';
import { setMember } from 'store/actions';
import Swal from 'sweetalert2';
import { calculateAge } from 'utils/tools';
import { DateField } from 'components/Common/fields';
import notify from 'utils/notify';
import {
  principalProblem,
  dependentProblem,
  waitingPeriodProblem,
  ruleFailure,
} from 'utils/claimRules';

const FormWizard = () => {
  document.title = 'Form Wizard | SUN Welfare Administration System';

  const [activeTab, setactiveTab] = useState(1);

  const [passedSteps, setPassedSteps] = useState([1]);
  const [deathDate, setDeathDate] = useState('');
  const [delayJustification, setDelayJustification] = useState('');
  const [delayed, setDelayed] = useState(false);
  const [serialNumber, setSerialNumber] = useState('');
  const [idNumber, setIdNumber] = useState(undefined);
  const [modal2, setModal2] = useState(false);
  const { member } = useSelector((state) => ({ member: state.member.member }));
  const dispatch = useDispatch();
  const [search, setSearch] = useState(false);
  const [claimError, setClaimError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [isGroupJoin, setIsGroupJoin] = useState(false);
  const [isMemberSelected, setIsMemberSelected] = useState(false);

  const [claimAttatchments, setClaimAttatchments] = useState({
    burialPermit: { file: {}, type: 'BurialPermit' },
    chiefLetter: { file: {}, type: 'LetterFromChief' },
    birthCert: { file: {}, type: 'BirthCertificate' },
    deceasedIdCard: { file: {}, type: 'DeceasedIdCard' },
    minutes: { file: {}, type: 'GroupMinutes' },
    grpRep1Id: { file: {}, type: 'GroupRep1Id' },
    grpRep2Id: { file: {}, type: 'GroupRep2Id' },
    // familyRepId: { file: {}, type: 'FamilyRepId' },
    nextOfKinId: { file: {}, type: 'IDNumber' },
  });

  const [deceased, setDeceased] = useState(null);
  const queryClient = useQueryClient();

  const [dependentsList, setDependentsList] = useState([]);

  const isValidDob = (dob) => {
    if (!dob) return false;

    const age = calculateAge(dob);

    return !isNaN(age) && age >= 0;
  };

  const dependantPill = (dep) => {
    if (dep?.relationship === 'Principal Member') return null;
    if (dep?.status === 'Deceased') return 'Deceased';
    const relationship = dep?.relationship?.toLowerCase();
    if (
      isValidDob(dep?.dob) &&
      relationship !== 'husband' &&
      relationship !== 'wife' &&
      calculateAge(dep.dob) >= 18
    ) {
      return 'Over 18';
    }
    if (dep?.status && dep.status !== 'Active') return dep.status;
    return null;
  };

  const isDependantEligible = (dep) => {
    if (dep?.relationship !== 'Principal Member' && dep?.status === 'Deceased') return false;
    if (!isValidDob(dep?.dob)) return false;
    const age = calculateAge(dep.dob);
    const relationship = dep?.relationship?.toLowerCase();
    if (
      (relationship === 'son' || relationship === 'daughter') &&
      age >= 18
    ) {
      return false;
    }

    return true;
  };

  useEffect(() => {
    mutatePolicies();
    if (member?.joinType === 'Group') {
      setIsGroupJoin(true);
    } else {
      setIsGroupJoin(false);
    }
  }, [member]);

  const {
    mutate: mutatePolicies,
    isLoading: isLoadingPolicies,
    data: policiesData,
  } = useMutation((payload) => getAllPolicyApi(payload), {
    onSettled: () => {
      queryClient.invalidateQueries('get-all-counties');
    },
  });

  const {
    mutate: mutateDependants,
    isLoading: isLoadingDependants,
    data: dependantsData,
  } = useMutation((payload) => getDependantsApi(payload), {
    onSuccess: (data) => {
      member['relationship'] = 'Principal Member';
      setDependentsList([member, ...data]);
    },
    onSettled: () => {
      queryClient.invalidateQueries('get-all-counties');
    },
  });

  const {
    mutate: mutateNextOfKin,
    isLoading: isLoadingNextOfKin,
    data: nextOfKinData,
  } = useMutation((payload) => getNextOfKinApi(payload), {
    onSettled: () => {
      queryClient.invalidateQueries('get-all-counties');
    },
  });

  function toggleTab(tab) {
    if (activeTab !== tab) {
      var modifiedSteps = [...passedSteps, tab];
      if (tab >= 1 && tab <= 3) {
        setactiveTab(tab);
        setPassedSteps(modifiedSteps);
      }
    }
  }

  const onChangeIdNumber = (value) => {
    setMember(null);
    setIdNumber(value);
    setSearch(false);
  };

  useEffect(() => {
    mutatePolicies();
  }, []);

  useEffect(() => {
    if (deceased && !isEmpty(member)) {
      setIsMemberSelected(!deceased?.dependentId);
    }
  }, [deceased]);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      idNumber: '',
    },
    validationSchema: Yup.object({
      idNumber: Yup.string().required('Please National ID Number/Passport'),
    }),
    onSubmit: async (values) => {
      const idNumber = values.idNumber;
      setIdNumber(idNumber);
      await getMemberByIdNumberApi(idNumber).then(async (m) => {
        await dispatch(setMember(m));
        if (m) {
          mutateNextOfKin({ memberId: m.memberId });
          mutateDependants({ memberId: m.memberId });
        }

        const problem = principalProblem(m);
        setClaimError(problem ? problem.text : '');
        if (problem) notify.warning(problem.title, problem.text);
        setSearch(true);
      });
    },
  });

  const documentsValidation = useFormik({
    enableReinitialize: true,
    initialValues: {
      deathDate: '',
      serialNumber: '',
      burialPermit: '',
      chiefLetter: '',
      deceasedIdCard: '',
      birthCert: '',
      minutes: '',
      delayJustification: '',
      grpRep1Id: '',
      grpRep2Id: '',
      // familyRepId: '',
      nextOfKinId: '',
    },
    validationSchema: Yup.object({
      deathDate: Yup.string().required('Please select date of death'),
      serialNumber: Yup.string()
        .matches(/^\d{1,9}$/, 'Serial number must be 1 to 7 digits')
        .required('Burial Permit Serial No. is required'),
      burialPermit: Yup.string().required('Burial Permit is required'),
      chiefLetter: Yup.string().required('Letter From Chief is required'),
      birthCert: Yup.string().when('birthCertRequired', {
        is: () => deceased && calculateAge(deceased.dob) < 18,
        then: (schema) => schema.required('Birth Certificate is required'),
      }),
      minutes: Yup.string().when('isGroupJoin', {
        is: true,
        then: (schema) => schema.notRequired(),
      }),
      grpRep1Id: Yup.string().when('isGroupJoin', {
        is: true,
        then: (schema) =>
          schema.required('Group Representative 1 ID is required!!!'),
      }),
      grpRep2Id: Yup.string().when('isGroupJoin', {
        is: true,
        then: (schema) =>
          schema.required('Group Representative 2 ID is required!!!'),
      }),
      // familyRepId: Yup.string().when('familyRepIdCard', {
      //   is: () => isMemberSelected,
      //   then: (schema) => schema.required('Family Member ID is required'),
      // }),
      delayJustification: Yup.string().when('delayed', {
        is: () => delayed,
        then: (schema) => schema.required('Delay Justification is required!!!'),
      }),
      nextOfKinId: Yup.string().when('isMemberSelected', {
        is: () => isMemberSelected,
        then: (schema) => schema.required('Next of Kin ID is required!!!'),
      }),
      deceasedIdCard: Yup.string().when('deceased', {
        is: (deceased) => deceased && calculateAge(deceased.dob) > 18,
        then: (schema) =>
          schema.required('Copy of Deceased ID Card is required!!!'),
      }),
    }),
    onSubmit: async ({ deathDate, ...values }) => {
      if (!isMemberSelected) {
        if (!calculateAge(deceased.dob)) {
          notify.error('Invalid Date of Birth', 'Deceased DOB is invalid.');
          return;
        }

      }
      if (!isValidDob(deceased?.dob)) {
        notify.error('Invalid Date of Birth', 'This dependant has no valid Date of Birth. Claim cannot proceed.');
        return;
      }
      const waiting = waitingPeriodProblem(deceased, deathDate);
      if (waiting) {
        notify.error(waiting.title, waiting.text);
        return;
      }
      // if (!isMemberSelected && !calculateAge(deceased.dob)) {
      //   Swal.fire({
      //     icon: 'error',
      //     title: 'Invalid Date of Birth',
      //     text: 'Deceased DOB is invalid.',
      //   });
      //   return;
      // }
      handleCreateClaim();
    },
  });

  const handleCreateClaim = async () => {
    if (submitting) return; // block retry-storm double-submits (clm/06)
    setSubmitting(true);
    try {
      const policy =
        policiesData &&
        policiesData.find((p) => p.policyNumber === 'WELF-202311263');
      const dependentIdToUse = isMemberSelected
        ? member?.memberId
        : deceased?.dependentId;

      const claimResponse = await addClaim({
        policyId: policy?.id,
        memberId: member.memberId,
        type: isMemberSelected ? 'Principal' : 'Dependent',
        burialPermitSerialNumber: serialNumber,
        delayJustification,
        deathCertificate: {
          firstName: deceased?.firstName || '',
          lastName: deceased?.lastName || '',
          deathDate: deathDate,
          dependentId: dependentIdToUse,
        },
      });

      const claimId = claimResponse.data;
      let actions = [];
      Object.entries(claimAttatchments).forEach(([key, value]) => {
        const { file, type } = value;
        file?.name && actions.push(uploadMedia(claimId, file, type));
      });
      await Promise.all(actions);
      notify.success('Claim Submitted!', 'Your claim has been successfully created.');
      toggleTab(3);
    } catch (error) {
      console.error(error);
      // Show error message with SweetAlert2
      const failure = ruleFailure(
        error?.message || 'There was an error creating your claim. Please try again.',
        'Submission Failed',
      );
      notify.error(failure.title, failure.text);
    } finally {
      setSubmitting(false);
    }
  };

  const handleRadioChange = (index) => {
    const data = dependentsList[index];
    setDeceased(data);
    documentsValidation.setFieldValue('birthCert', '');
    const problem = dependentProblem(data);
    if (problem) notify.warning(problem.title, problem.text);
  };

  const handleFileChange = (e) => {
    const key = e.target.name;
    setClaimAttatchments({
      ...claimAttatchments,
      [key]: { ...claimAttatchments[key], file: e.target.files[0] },
    });
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="Claims" breadcrumbItem="New Claim" />
          <Row>
            <Link to="/claims/all">
              <Button type="button" color="primary" className="btn">
                <i className="bx bx-arrow-back"></i> Back
              </Button>
            </Link>
            <Col lg="12">
              <Card>
                <CardBody>
                  <h4 className="card-title mb-4">Make A Claim</h4>
                  <div className="wizard clearfix">
                    <div className="steps clearfix">
                      <ul>
                        <NavItem
                          className={classnames({ current: activeTab === 1 })}
                        >
                          <NavLink
                            className={classnames({ current: activeTab === 1 })}
                            onClick={() => {
                              setactiveTab(1);
                            }}
                            disabled={!(passedSteps || []).includes(1)}
                          >
                            <span className="number">1.</span> Member Details
                          </NavLink>
                        </NavItem>

                        <NavItem
                          className={classnames({ current: activeTab === 2 })}
                        >
                          <NavLink
                            className={classnames({ current: activeTab === 2 })}
                            onClick={() => {
                              setactiveTab(2);
                            }}
                            disabled={!(passedSteps || []).includes(1)}
                          >
                            <span className="number">2.</span> Upload Documents
                          </NavLink>
                        </NavItem>

                        <NavItem
                          className={classnames({ current: activeTab === 3 })}
                        >
                          <NavLink
                            className={classnames({ active: activeTab === 3 })}
                            onClick={() => {
                              setactiveTab(3);
                            }}
                            disabled={!(passedSteps || []).includes(2)}
                          >
                            <span className="number">3.</span> Confirm Details
                          </NavLink>
                        </NavItem>
                      </ul>
                    </div>
                    <div className="content clearfix">
                      <TabContent activeTab={activeTab} className="body">
                        <TabPane tabId={1}>
                          {isLoadingPolicies && <LoadingSpinner />}
                          <Form
                            autoComplete="off"
                            onSubmit={(e) => {
                              e.preventDefault();
                              validation.handleSubmit();
                              return false;
                            }}
                          >
                            <Row>
                              <Col lg="12">
                                <div className="mb-3">
                                  <Label for="basicpill-pancard-input5">
                                    Principal Member National ID Number
                                  </Label>
                                  <Input
                                    id="idNumber"
                                    name="idNumber"
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter principal ID number"
                                    onChange={(e) => {
                                      validation.handleChange(e);
                                      onChangeIdNumber(e.target.value);
                                    }}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.idNumber || ''}
                                    invalid={
                                      validation.touched.idNumber &&
                                        validation.errors.idNumber
                                        ? true
                                        : false
                                    }
                                  />
                                  {validation.touched.idNumber &&
                                    validation.errors.idNumber ? (
                                    <FormFeedback type="invalid">
                                      {validation.errors.idNumber}
                                    </FormFeedback>
                                  ) : null}
                                </div>
                              </Col>
                            </Row>
                            {idNumber && search && !member && (
                              <h4 className="my-5  fs-5 text text-danger">
                                No member found with this ID Number
                              </h4>
                            )}

                            <Row>
                              <Col lg="2" sm="12" md="8">
                                <Button
                                  type="submit"
                                  color="primary"
                                  block
                                  className="mt-4 d-flex align-items-center justify-content-center"
                                >
                                  Search Claimant{' '}
                                  <i className="bx bx-search-alt search-icon fs-4 ms-2"></i>
                                </Button>
                              </Col>
                            </Row>

                            {!isEmpty(member) && (
                              <Row className="mt-5">
                                <Col>
                                  <CardTitle className="h4">
                                    Principal Member
                                  </CardTitle>
                                  <p className="card-title-desc">
                                    Confirm that this is the principle member
                                    under which a claim is being raised.
                                  </p>

                                  <div className="table-responsive">
                                    <Table className="table mb-0 table-striped">
                                      <thead>
                                        <tr>
                                          <th>#</th>
                                          <th>Full Name</th>
                                          <th>Mobile Number</th>
                                          <th>ID Number</th>
                                          <th>Member Status</th>
                                          <th>Policy Status</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr>
                                          <th scope="row">1</th>
                                          <td>{`${member?.firstName} ${member?.middleName || ''
                                            } ${member?.lastName}`}</td>
                                          <td>{member?.mobileNumber1}</td>
                                          <td>
                                            {member?.identificationNumber}
                                          </td>
                                          <td>{member?.status}</td>
                                          <td>
                                            {member?.policyMatured
                                              ? 'Matured'
                                              : 'Not Matured'}
                                          </td>
                                        </tr>
                                      </tbody>
                                    </Table>
                                  </div>
                                  {nextOfKinData && nextOfKinData[0] && (
                                    <>
                                      <CardTitle className="h4">
                                        Next Of Kin
                                      </CardTitle>
                                      <p className="card-title-desc">
                                        Confirm next of kin
                                      </p>

                                      <div className="table-responsive">
                                        <Table className="table mb-0 table-striped">
                                          <thead>
                                            <tr>
                                              <th>#</th>
                                              <th>Full Name</th>
                                              <th>Mobile Number</th>
                                              <th>Gender</th>
                                              <th>DOB</th>
                                              <th>Designation</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            <tr>
                                              <th scope="row">1</th>
                                              <td>{`${nextOfKinData[0].firstName || ''
                                                } ${nextOfKinData[0].middleName ||
                                                ''
                                                } ${nextOfKinData[0].lastName || ''
                                                }`}</td>
                                              <td>
                                                {nextOfKinData[0].mobileNumber}
                                              </td>
                                              <td>{nextOfKinData[0].gender}</td>
                                              <td>{nextOfKinData[0].dob}</td>
                                              <td>
                                                {nextOfKinData[0].relationship}
                                              </td>
                                            </tr>
                                          </tbody>
                                        </Table>
                                      </div>
                                    </>
                                  )}
                                  <CardTitle className="h4 mt-5">
                                    Dependants
                                  </CardTitle>
                                  <p className="card-title-desc">
                                    Select deceased from member list
                                  </p>
                                  <div className="table-responsive">
                                    <Table className="table mb-0 table-striped">
                                      <thead>
                                        <tr>
                                          <th>Select</th>
                                          <th>#</th>
                                          <th>Full Name</th>
                                          <th>Gender</th>
                                          <th>Date Of Birth</th>
                                          <th>Designation</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {dependentsList &&
                                          dependentsList.map(
                                            (d, index) =>
                                              d && (
                                                <tr key={JSON.stringify(d)}>
                                                  <td>
                                                    <FormGroup check>
                                                      <Input
                                                        type="radio"
                                                        name="dep"
                                                        style={{ transform: 'scale(1.5)' }}
                                                        disabled={!isDependantEligible(d)}
                                                        onChange={() => handleRadioChange(index)}
                                                      />
                                                      {'  '}
                                                    </FormGroup>
                                                  </td>
                                                  <th scope="row">
                                                    {index + 1}
                                                  </th>
                                                  <td>
                                                    {`${d?.firstName || ''} ${d?.middleName || ''
                                                      } ${d.lastName || ''}`}
                                                    {dependantPill(d) && (
                                                      <span
                                                        className={`badge font-size-12 ms-2 ${dependantPill(d) === 'Deceased' ? 'badge-soft-danger' : 'badge-soft-warning'}`}
                                                      >
                                                        {dependantPill(d)}
                                                      </span>
                                                    )}
                                                  </td>
                                                  <td>
                                                    {d &&
                                                      (d.gender ||
                                                        d.birthCertificationNumber)
                                                      ? `${d.gender
                                                        ? d.gender
                                                        : ''
                                                      } ${d.birthCertificationNumber
                                                        ? `(${d.birthCertificationNumber})`
                                                        : ''
                                                      }`
                                                      : ''}
                                                  </td>
                                                  <td>
                                                    {d?.dob && isValidDob(d.dob)
                                                      ? `${calculateAge(d.dob)} yrs`
                                                      : <span className="text-danger">Missing DOB</span>}
                                                  </td>
                                                  <td>
                                                    {d?.relationship}
                                                    {!isDependantEligible(d) && (
                                                      <span className="text-danger ms-2">
                                                        (Not Eligible)
                                                      </span>
                                                    )}
                                                  </td>
                                                </tr>
                                              ),
                                          )}
                                        {!dependentsList && (
                                          <tr>
                                            <td colSpan="5">
                                              No dependents found for this
                                              member.
                                            </td>
                                          </tr>
                                        )}
                                      </tbody>
                                    </Table>
                                  </div>
                                  <h6 className="mt-3 text-muted">
                                    Select deceased from member list
                                  </h6>
                                </Col>
                              </Row>
                            )}
                          </Form>
                        </TabPane>
                        <TabPane tabId={2}>
                          {isLoadingPolicies && <LoadingSpinner />}
                          <div>
                            <Form onSubmit={documentsValidation.handleSubmit}>
                              <Row>
                                <Col lg="6">
                                  <FormGroup className="mb-3">
                                    <Label for="deathDate">Date Of death</Label>
                                    <DateField
                                      name="deathDate"
                                      id="deathDate"
                                      value={deathDate}
                                      placeholder="Select Date of Death"
                                      onChange={(e) => {
                                        const selectedDate = new Date(e.target.value);
                                        const today = new Date();

                                        // Remove time portion for accurate comparison
                                        selectedDate.setHours(0, 0, 0, 0);
                                        today.setHours(0, 0, 0, 0);

                                        const diffDays = Math.floor(
                                          (today - selectedDate) / (1000 * 60 * 60 * 24)
                                        );

                                        if (diffDays > 21) {
                                          setDelayed(true);
                                        }

                                        setDeathDate(e.target.value);
                                        documentsValidation.handleChange(e);
                                        const waiting = waitingPeriodProblem(deceased, e.target.value);
                                        if (waiting) notify.warning(waiting.title, waiting.text);
                                      }}
                                      onBlur={documentsValidation.handleBlur}
                                      // min={
                                      //   new Date(
                                      //     new Date().setDate(
                                      //       new Date().getDate() - 21,
                                      //     ),
                                      //   )
                                      //     .toISOString()
                                      //     .split('T')[0]
                                      // }
                                      max={
                                        new Date().toISOString().split('T')[0]
                                      }
                                      invalid={
                                        documentsValidation.touched.deathDate &&
                                        documentsValidation.errors.deathDate
                                      }
                                    />
                                    {documentsValidation.touched.deathDate &&
                                      documentsValidation.errors.deathDate && (
                                        <FormFeedback type="invalid">
                                          {documentsValidation.errors.deathDate}
                                        </FormFeedback>
                                      )}
                                  </FormGroup>
                                </Col>
                                <Col lg="6">
                                  <FormGroup className="mb-3">
                                    <Label for="serialNumber">
                                      Burial Permit Serial Number
                                    </Label>
                                    <Input
                                      name="serialNumber"
                                      type="number"
                                      max={9999999}
                                      className="form-control"
                                      id="serialNumber"
                                      placeholder="Enter Burial Permit Serial Number"
                                      onChange={(e) => {
                                        // Trim to max 9 digits
                                        const value = e.target.value;
                                        if (value.length <= 9) {
                                          setSerialNumber(value);
                                          documentsValidation.handleChange(e);
                                        }
                                      }}
                                      onBlur={documentsValidation.handleBlur}
                                      invalid={
                                        documentsValidation.touched
                                          .serialNumber &&
                                        documentsValidation.errors.serialNumber
                                      }
                                    />
                                    {documentsValidation.touched.serialNumber &&
                                      documentsValidation.errors
                                        .serialNumber && (
                                        <FormFeedback type="invalid">
                                          {
                                            documentsValidation.errors
                                              .serialNumber
                                          }
                                        </FormFeedback>
                                      )}
                                  </FormGroup>
                                </Col>
                              </Row>
                              <Row>
                                <Col lg="6">
                                  <div className="mb-3">
                                    <Label for="burialPermit">
                                      Burial Permit
                                    </Label>
                                    <Input
                                      type="file"
                                      className="form-control"
                                      name="burialPermit"
                                      id="burialPermit"
                                      onChange={(e) => {
                                        handleFileChange(e);
                                        documentsValidation.handleChange(e);
                                      }}
                                      onBlur={documentsValidation.handleBlur}
                                      invalid={
                                        documentsValidation.touched
                                          .burialPermit &&
                                        documentsValidation.errors.burialPermit
                                      }
                                    />
                                    {documentsValidation.touched.burialPermit &&
                                      documentsValidation.errors
                                        .burialPermit && (
                                        <FormFeedback type="invalid">
                                          {
                                            documentsValidation.errors
                                              .burialPermit
                                          }
                                        </FormFeedback>
                                      )}
                                  </div>
                                </Col>
                                <Col lg="6">
                                  <div className="mb-3">
                                    <Label for="chiefLetter">
                                      Letter From Chief
                                    </Label>
                                    <Input
                                      type="file"
                                      name="chiefLetter"
                                      className="form-control"
                                      id="chiefLetter"
                                      onChange={(e) => {
                                        handleFileChange(e);
                                        documentsValidation.handleChange(e);
                                      }}
                                      onBlur={documentsValidation.handleBlur}
                                      invalid={
                                        documentsValidation.touched
                                          .chiefLetter &&
                                        documentsValidation.errors.chiefLetter
                                      }
                                    />
                                    {documentsValidation.touched.chiefLetter &&
                                      documentsValidation.errors
                                        .chiefLetter && (
                                        <FormFeedback type="invalid">
                                          {
                                            documentsValidation.errors
                                              .chiefLetter
                                          }
                                        </FormFeedback>
                                      )}
                                  </div>
                                </Col>
                              </Row>
                              <Row>
                                {deceased &&
                                  calculateAge(deceased.dob) < 18 && (
                                    <Col lg="6">
                                      <div className="mb-3">
                                        <Label for="birthCert">
                                          Birth Certificate
                                        </Label>
                                        <Input
                                          name="birthCert"
                                          type="file"
                                          className="form-control"
                                          id="birthCert"
                                          onChange={(e) => {
                                            handleFileChange(e);
                                            documentsValidation.handleChange(e);
                                          }}
                                          onBlur={
                                            documentsValidation.handleBlur
                                          }
                                          invalid={
                                            documentsValidation.touched
                                              .birthCert &&
                                            documentsValidation.errors.birthCert
                                          }
                                        />
                                        {documentsValidation.touched
                                          .birthCert &&
                                          documentsValidation.errors
                                            .birthCert && (
                                            <FormFeedback type="invalid">
                                              {
                                                documentsValidation.errors
                                                  .birthCert
                                              }
                                            </FormFeedback>
                                          )}
                                      </div>
                                    </Col>
                                  )}
                                {(isMemberSelected ||
                                  (deceased &&
                                    (!calculateAge(deceased.dob) ||
                                      calculateAge(deceased.dob) > 18))) && (
                                    <Col lg="6">
                                      <div className="mb-3">
                                        <Label for="deceasedIdCard">
                                          Copy of Deceased National ID Card
                                        </Label>
                                        <Input
                                          name="deceasedIdCard"
                                          type="file"
                                          className="form-control"
                                          id="deceasedIdCard"
                                          onChange={(e) => {
                                            handleFileChange(e);
                                            documentsValidation.handleChange(e);
                                          }}
                                          onBlur={documentsValidation.handleBlur}
                                          invalid={
                                            documentsValidation.touched
                                              .deceasedIdCard &&
                                            documentsValidation.errors
                                              .deceasedIdCard
                                          }
                                        />
                                        {documentsValidation.touched
                                          .deceasedIdCard &&
                                          documentsValidation.errors
                                            .deceasedIdCard && (
                                            <FormFeedback type="invalid">
                                              {
                                                documentsValidation.errors
                                                  .deceasedIdCard
                                              }
                                            </FormFeedback>
                                          )}
                                      </div>
                                    </Col>
                                  )}
                                {delayed &&
                                  <Col lg="6">
                                    <FormGroup className="mb-3">
                                      <Label for="delayJustification">
                                        Delay Justification
                                      </Label>
                                      <Input
                                        name="delayJustification"
                                        type="text"
                                        className="form-control"
                                        id="delayJustification"
                                        placeholder="Please justify why the claim delayed"
                                        onChange={(e) => {
                                          const value = e.target.value;
                                          setDelayJustification(value);
                                          documentsValidation.handleChange(e);
                                        }}
                                        onBlur={documentsValidation.handleBlur}
                                        invalid={
                                          documentsValidation.touched
                                            .delayJustification &&
                                          documentsValidation.errors.delayJustification
                                        }
                                      />
                                      {documentsValidation.touched.delayJustification &&
                                        documentsValidation.errors
                                          .delayJustification && (
                                          <FormFeedback type="invalid">
                                            {
                                              documentsValidation.errors
                                                .delayJustification
                                            }
                                          </FormFeedback>
                                        )}
                                    </FormGroup>
                                  </Col>
                                }
                                {/* <Col lg="6">
                                  <div className="mb-3">
                                    <Label for="familyRepId">
                                      Family Member ID
                                    </Label>
                                    <Input
                                      type="file"
                                      name="familyRepId"
                                      className="form-control"
                                      id="familyRepId"
                                      onChange={(e) => {
                                        handleFileChange(e);
                                        documentsValidation.handleChange(e);
                                      }}
                                      onBlur={documentsValidation.handleBlur}
                                      invalid={
                                        documentsValidation.touched
                                          .familyRepId &&
                                        documentsValidation.errors.familyRepId
                                      }
                                    />
                                    {documentsValidation.touched.familyRepId &&
                                      documentsValidation.errors
                                        .familyRepId && (
                                        <FormFeedback type="invalid">
                                          {
                                            documentsValidation.errors
                                              .familyRepId
                                          }
                                        </FormFeedback>
                                      )}
                                  </div>
                                </Col> */}
                              </Row>
                              <Row>
                                <Col lg="6">
                                  <div className="mb-3">
                                    <Label for="nextOfKinId">
                                      Next of Kin National ID
                                    </Label>
                                    <Input
                                      name="nextOfKinId"
                                      type="file"
                                      className="form-control"
                                      id="nextOfKinId"
                                      onChange={(e) => {
                                        handleFileChange(e);
                                        documentsValidation.handleChange(e);
                                      }}
                                      onBlur={documentsValidation.handleBlur}
                                      invalid={
                                        documentsValidation.touched
                                          .nextOfKinId &&
                                        documentsValidation.errors.nextOfKinId
                                      }
                                    />
                                    {documentsValidation.touched.nextOfKinId &&
                                      documentsValidation.errors
                                        .nextOfKinId && (
                                        <FormFeedback type="invalid">
                                          {
                                            documentsValidation.errors
                                              .nextOfKinId
                                          }
                                        </FormFeedback>
                                      )}
                                  </div>
                                </Col>
                                {isGroupJoin && (
                                  <Col lg="6">
                                    <div className="mb-3">
                                      <Label for="minutes">
                                        Meeting Minutes (Optional)
                                      </Label>
                                      <Input
                                        name="minutes"
                                        type="file"
                                        className="form-control"
                                        id="minutes"
                                        onChange={(e) => {
                                          handleFileChange(e);
                                          documentsValidation.handleChange(e);
                                        }}
                                        onBlur={documentsValidation.handleBlur}
                                        invalid={
                                          documentsValidation.touched.minutes &&
                                          documentsValidation.errors.minutes
                                        }
                                      />
                                      {documentsValidation.touched.minutes &&
                                        documentsValidation.errors.minutes && (
                                          <FormFeedback type="invalid">
                                            {documentsValidation.errors.minutes}
                                          </FormFeedback>
                                        )}
                                    </div>
                                  </Col>
                                )}
                              </Row>
                              {isGroupJoin && (
                                <Row>
                                  <Col lg="6">
                                    <div className="mb-3">
                                      <Label for="grpRep1Id">
                                        Group Representative 1 National ID
                                      </Label>
                                      <Input
                                        type="file"
                                        name="grpRep1Id"
                                        className="form-control"
                                        id="grpRep1Id"
                                        onChange={(e) => {
                                          handleFileChange(e);
                                          documentsValidation.handleChange(e);
                                        }}
                                        onBlur={documentsValidation.handleBlur}
                                        invalid={
                                          documentsValidation.touched
                                            .grpRep1Id &&
                                          documentsValidation.errors.grpRep1Id
                                        }
                                      />
                                      {documentsValidation.touched.grpRep1Id &&
                                        documentsValidation.errors
                                          .grpRep1Id && (
                                          <FormFeedback type="invalid">
                                            {
                                              documentsValidation.errors
                                                .grpRep1Id
                                            }
                                          </FormFeedback>
                                        )}
                                    </div>
                                  </Col>
                                  <Col lg="6">
                                    <div className="mb-3">
                                      <Label for="grpRep2Id">
                                        Group Representative 2 National ID
                                      </Label>
                                      <Input
                                        type="file"
                                        name="grpRep2Id"
                                        className="form-control"
                                        id="grpRep2Id"
                                        onChange={(e) => {
                                          handleFileChange(e);
                                          documentsValidation.handleChange(e);
                                        }}
                                        onBlur={documentsValidation.handleBlur}
                                        invalid={
                                          documentsValidation.touched
                                            .grpRep2Id &&
                                          documentsValidation.errors.grpRep2Id
                                        }
                                      />
                                      {documentsValidation.touched.grpRep2Id &&
                                        documentsValidation.errors
                                          .grpRep2Id && (
                                          <FormFeedback type="invalid">
                                            {
                                              documentsValidation.errors
                                                .grpRep2Id
                                            }
                                          </FormFeedback>
                                        )}
                                    </div>
                                  </Col>
                                </Row>
                              )}
                            </Form>
                          </div>
                        </TabPane>
                        <TabPane tabId={3}>
                          {isLoadingPolicies && <LoadingSpinner />}
                          <div className="row justify-content-center">
                            <Col lg="6">
                              <div className="text-center">
                                <div className="mb-4">
                                  <i className="mdi mdi-check-circle-outline text-success display-4" />
                                </div>
                                <div>
                                  <h5>Submit Detail</h5>
                                  <p className="text-muted">
                                    Claim Successfully Submitted!
                                  </p>
                                </div>
                              </div>
                            </Col>
                          </div>
                        </TabPane>
                      </TabContent>
                    </div>
                    <div className="actions clearfix">
                      <ul>
                        <li
                          className={
                            activeTab === 1 ? 'previous disabled' : 'previous'
                          }
                        >
                          <Link
                            to="#"
                            onClick={() => {
                              toggleTab(activeTab - 1);
                            }}
                          >
                            Previous
                          </Link>
                        </li>
                        <li
                          className={
                            activeTab === 3 ||
                              (isEmpty(member) && isNull(deceased))
                              ? 'next disabled'
                              : 'next'
                          }
                        >
                          {/* <Link
                            to="#"
                            onClick={activeTab === 2 ? () => handleCreateClaim() : () => toggleTab(activeTab + 1)
                            }
                          >
                            {activeTab === 2 ? 'Submit' : 'Next'}
                          </Link> */}
                          <Button
                            type="button"
                            color="primary"
                            onClick={() => {
                              if (activeTab === 2) {
                                documentsValidation.handleSubmit();
                              } else {
                                toggleTab(activeTab + 1);
                              }
                            }}
                            disabled={
                              submitting ||
                              (activeTab === 1 &&
                              (
                                isEmpty(member) ||
                                isEmpty(deceased) ||
                                !isValidDob(deceased?.dob) ||
                                member.policyMatured === false ||
                                member.status !== 'Active' ||
                                !!dependentProblem(deceased)
                              ))
                            }
                          >
                            {activeTab === 2
                              ? submitting
                                ? 'Submitting...'
                                : 'Submit'
                              : 'Next'}
                          </Button>
                        </li>
                      </ul>
                      {activeTab === 1 && member && (
                        <span className="text-danger ml-2">
                          {claimError || dependentProblem(deceased)?.text}
                        </span>
                      )}
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <ClaimStatusModal
        show={modal2 && member}
        member={member || {}}
        onCloseClick={() => setModal2(false)}
      />
    </React.Fragment>
  );
};

export default FormWizard;
